import React, { Component } from 'react';
import { UtilService } from 'hay-core-react';
// Mesma escala de Configuracao.TAMANHOFONTECAPTIVE_TAMANHOS (api/models/Configuracao.js) em rem, só
// para a prévia visual — o valor de fato aplicado no reactcaptive vem do backend (font-size do <html>).
const TAMANHO_PREVIEW = {
    'main.configuracao.tamanhofontecaptive.pequeno': '0.875rem',
    'main.configuracao.tamanhofontecaptive.menor': '0.9375rem',
    'main.configuracao.tamanhofontecaptive.normal': '1rem',
    'main.configuracao.tamanhofontecaptive.maior': '1.125rem',
    'main.configuracao.tamanhofontecaptive.grande': '1.25rem',
};

// Rótulo de opção/valor do dropdown de Configuracao.tamanhofontecaptive: "Aa" renderizado no
// tamanho relativo da opção + label traduzido ("Grande" etc.). Usado via itemTemplateCustom/
// valueTemplateCustom do ModelDropDown, mesmo padrão de TemaCaptiveOptionLabel.
class TamanhoFonteCaptiveOptionLabel extends Component {
    render() {
        const { chave } = this.props;
        if (!chave) {
            return <div className="flex align-items-center"><div>Selecione</div></div>;
        }
        return (
            <div className="flex align-items-center gap-2">
                <span style={{ fontSize: TAMANHO_PREVIEW[chave] || TAMANHO_PREVIEW['main.configuracao.tamanhofontecaptive.normal'], fontWeight: 700, width: '1.5rem', flexShrink: 0 }}>Aa</span>
                <span>{UtilService.traduzir(chave)}</span>
            </div>
        );
    }
}

export default TamanhoFonteCaptiveOptionLabel;
